import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function AddUserIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} height={20} width={20} viewBox={'0 0 20 20'}>
      <path d="M12.5 10C14.3417 10 15.8334 8.50837 15.8334 6.66671C15.8334 4.82504 14.3417 3.33337 12.5 3.33337C10.6584 3.33337 9.16671 4.82504 9.16671 6.66671C9.16671 8.50837 10.6584 10 12.5 10ZM12.5 5.00004C13.4167 5.00004 14.1667 5.75004 14.1667 6.66671C14.1667 7.58337 13.4167 8.33337 12.5 8.33337C11.5834 8.33337 10.8334 7.58337 10.8334 6.66671C10.8334 5.75004 11.5834 5.00004 12.5 5.00004ZM12.5 11.6667C10.275 11.6667 5.83337 12.7834 5.83337 15V16.6667H19.1667V15C19.1667 12.7834 14.725 11.6667 12.5 11.6667ZM7.50004 15C7.68337 14.4 10.2584 13.3334 12.5 13.3334C14.75 13.3334 17.3334 14.4084 17.5 15H7.50004ZM5.00004 12.5V10H7.50004V8.33337H5.00004V5.83337H3.33337V8.33337H0.833374V10H3.33337V12.5H5.00004Z"/>
    </SvgIcon>
  );
}

/*
      <g clipPath="url(#clip0_6096_273)">
        <path d="M12.5 10C14.3417 10 15.8334 8.50837 15.8334 6.66671C15.8334 4.82504 14.3417 3.33337 12.5 3.33337C10.6584 3.33337 9.16671 4.82504 9.16671 6.66671C9.16671 8.50837 10.6584 10 12.5 10ZM12.5 5.00004C13.4167 5.00004 14.1667 5.75004 14.1667 6.66671C14.1667 7.58337 13.4167 8.33337 12.5 8.33337C11.5834 8.33337 10.8334 7.58337 10.8334 6.66671C10.8334 5.75004 11.5834 5.00004 12.5 5.00004ZM12.5 11.6667C10.275 11.6667 5.83337 12.7834 5.83337 15V16.6667H19.1667V15C19.1667 12.7834 14.725 11.6667 12.5 11.6667ZM7.50004 15C7.68337 14.4 10.2584 13.3334 12.5 13.3334C14.75 13.3334 17.3334 14.4084 17.5 15H7.50004ZM5.00004 12.5V10H7.50004V8.33337H5.00004V5.83337H3.33337V8.33337H0.833374V10H3.33337V12.5H5.00004Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_6096_273">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>

*/

